import React, { useState } from 'react';
import { InputNumber } from 'antd';

// const InitialInvestment= ({onInvestmentChange, value}) => {
  

//   const handleNumberChange = (value) => {
//     // You can perform any validation or processing here
//     //setNumberValue(value);
//     onInvestmentChange(value)
//   };

 
//   return (
//     <div >
//       <InputNumber
//         id="numberInput"
//         value={value}
//         min={1}
//         onChange={handleNumberChange}
//         style={{ backgroundColor: 'black', inputColor:'white'}}
//         //formatter={formatNumber}
//       />
//     </div>
//   );
// };

// export default InitialInvestment;





const InitialInvestment = ({ onInvestmentChange, value }) => {
  const handleNumberChange = (event) => {
    const newValue = parseInt(event.target.value, 10);
    onInvestmentChange(newValue);
  };

  return (
    <div>
      <input
        type="number"
        value={value}
        min={1}
        onChange={handleNumberChange}
        style={{
          backgroundColor: 'black',
          color: 'white',
          padding: '3px',
          borderRadius: '4px',
          border: '1px solid white',
          width: '100px'
        }}
      />
    </div>
  );
};

export default InitialInvestment;
